export var slippageDefaultOptions = [{ value: '3000', name: '0.3%', decimals: 4 }, { value: '5000', name: '0.5%', decimals: 4 }, { value: '10000', name: '1%', decimals: 4 }];
